import {
  SettingsTab,
  SettingsTabsCollection,
  getTabIndex,
} from '~/lib/util/settings.util';

import SettingsPanels from './panels';
import { PortalComponent } from '../../../lib/contexts/ComponentPortalContext';
import { Path } from '../../../routes/constants';
import Tabs from '../../common/tabs';

const SettingsTabs = () => (
  <Tabs<SettingsTab>
    basePath={Path.SETTINGS}
    componentPortalContextKey="saveSettings"
    defaultPath={SettingsTabsCollection[SettingsTab.GENERAL].subPath}
    getTabIndex={getTabIndex}
    Panels={SettingsPanels}
    portalComponent={PortalComponent.SAVE_SETTINGS}
    tabsDictionary={SettingsTabsCollection}
    title="Settings"
  />
);

export default SettingsTabs;
